import React from 'react';

import {
  DateField, RecordContextProvider, useRecordContext,
} from 'react-admin';

import {
  Box,
  Grid,
  Card,
  CardHeader,
  Divider,
  CardContent,
  Typography,
  Link,
} from '@mui/material';

import { isEmpty } from 'lodash';

import { PepMatches } from '../../../../../../utilities/schemas/pepMatches';
import getBaseUrl from '../../../../../../utilities/getBaseUrl';

import PepTitle from './PepTitle';

type SourceDetails = PepMatches['potentialMatches'][number]['sourceDetails'][number];

const Source = () => {
  const record = useRecordContext<SourceDetails>();

  const title = isEmpty(record?.title) ? 'Unknown title' : record!.title;
  const description = isEmpty(record?.description) ? 'No description' : record!.description;

  const enableDocumentLink = !isEmpty(record?.documentLink);
  const enableLink = !isEmpty(record?.link);

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" alignItems="baseline" gap={1}>
        <PepTitle>
          {title}
        </PepTitle>
        {record?.datePublished && (
          <>
            <Typography variant="label" sx={{ fontSize: 13 }}>
              Date published:
            </Typography>
            <DateField
              sx={{
                fontSize: 13,
              }}
              variant="label"
              source="datePublished"
              emptyText="-"
            />
          </>
        )}
        {record?.dateAdded && (
          <>
            <Typography variant="label" sx={{ fontSize: 13 }}>
              Date captured:
            </Typography>
            <DateField
              sx={{
                fontSize: 13,
              }}
              variant="label"
              source="dateAdded"
              emptyText="-"
            />
          </>
        )}
      </Box>
      <Typography variant="body2">
        {description}
      </Typography>
      {enableDocumentLink && (
        <Link
          href={record!.documentLink}
          color="primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          PDF link
        </Link>
      )}
      {enableLink && (
        <Link
          href={record!.link}
          color="primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {getBaseUrl(record!.link!)}
        </Link>
      )}
    </Box>
  );
};

const PepSources = () => {
  const record = useRecordContext<PepMatches['potentialMatches'][number]>();

  if (!record) {
    return null;
  }

  if (isEmpty(record.sourceDetails)) {
    return null;
  }

  return (
    <Grid size={12}>
      <Card variant="outlined" sx={{ margin: 0 }}>
        <CardHeader title="Sources" />
        <Divider />
        <CardContent>
          <Box display="flex" gap={6} flexDirection="column">
            {record.sourceDetails.map((source) => (
              <RecordContextProvider key={source.title} value={source}>
                <Source />
              </RecordContextProvider>
            ))}
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default PepSources;
